import React, { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Loader2, X } from "lucide-react";
import api from "../../lib/api";
import { Field } from "./shared";

const LevelHelpModal = ({ onClose }) => {
  const [form, setForm] = useState({ parentName: "", email: "", phone: "", childName: "", childAge: "", previousExperience: "", message: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.parentName || !form.email || !form.childName || !form.message) {
      toast.error("Merci de renseigner les champs obligatoires.");
      return;
    }
    setSending(true);
    try {
      await api.post("/level-requests", form);
      setDone(true);
    } catch {
      toast.error("Erreur lors de l'envoi. Réessayez plus tard.");
    } finally { setSending(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-stone-900/70 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6 overflow-y-auto" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-3xl shadow-xl max-w-2xl w-full p-6 sm:p-8 my-8 relative">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 rounded-full bg-stone-100 hover:bg-stone-200 text-stone-600"><X size={18}/></button>
        {done ? (
          <div className="text-center py-8" data-testid="level-request-done">
            <CheckCircle2 size={56} className="mx-auto text-emerald-500" />
            <h3 className="font-serif-display text-2xl text-stone-800 mt-5">Demande envoyée&nbsp;!</h3>
            <p className="text-stone-600 mt-3">Nous reviendrons vers vous dans les meilleurs délais pour vous recommander le cours le plus adapté à votre enfant.</p>
            <button onClick={onClose} className="mt-6 inline-flex items-center gap-2 bg-coral text-white px-6 py-2.5 rounded-full text-sm tracking-widest uppercase">Fermer</button>
          </div>
        ) : (
          <>
            <h3 className="font-serif-display text-2xl text-stone-800">Demande de conseil de niveau</h3>
            <p className="text-stone-500 text-sm mt-1">Décrivez-nous votre enfant&nbsp;: nous vous recommanderons le cours adapté avant l&apos;inscription officielle.</p>
            <form onSubmit={submit} className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4" autoComplete="on">
              <Field label="Votre nom *" name="name" autoComplete="name" placeholder="Marie Dupont" value={form.parentName} onChange={update("parentName")} small required />
              <Field label="Email *" type="email" name="email" autoComplete="email" inputMode="email" placeholder="marie@email.fr" value={form.email} onChange={update("email")} small required />
              <Field label="Téléphone" type="tel" name="tel" autoComplete="tel" inputMode="tel" placeholder="06 12 34 56 78" value={form.phone} onChange={update("phone")} small />
              <Field label="Prénom de l'enfant *" name="child-first" autoComplete="off" placeholder="Léa" value={form.childName} onChange={update("childName")} small required />
              <Field label="Âge de l'enfant" name="child-age" autoComplete="off" inputMode="numeric" pattern="[0-9]{1,2}" placeholder="Ex: 8" value={form.childAge} onChange={update("childAge")} small />
              <Field label="Expérience préc. (années, école...)" name="prev-experience" autoComplete="off" placeholder="2 ans à l'école X..." value={form.previousExperience} onChange={update("previousExperience")} small />
              <div className="sm:col-span-2">
                <label className="block text-xs uppercase tracking-widest text-stone-500 mb-1.5">Votre message *</label>
                <textarea value={form.message} onChange={update("message")} rows={4} placeholder="Décrivez ce que vous recherchez, le niveau souhaité, les disponibilités..." className="w-full bg-cream rounded-xl border border-blush-light px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blush" />
              </div>
              <div className="sm:col-span-2 flex flex-col sm:flex-row gap-3 justify-end">
                <button type="button" onClick={onClose} className="px-5 py-2 rounded-full bg-stone-100 text-stone-700 text-sm">Annuler</button>
                <button type="submit" disabled={sending} className="px-6 py-2 rounded-full bg-coral text-white text-sm tracking-widest uppercase disabled:opacity-50 inline-flex items-center justify-center gap-2">
                  {sending ? (<><Loader2 className="animate-spin" size={14}/> Envoi...</>) : "Envoyer ma demande"}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default LevelHelpModal;
